// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import './Reports.css';

// // --- API Configuration ---
// // The API base URL is now sourced from environment variables for better flexibility.
// // A fallback to the local development URL is provided if the variable isn't set.
// const API_BASE_URL = process.env.REACT_APP_REPORTS_API_URL;
// const initialFormState = {
//     report_name: '',
//     module_name: '',
//     sql_query: '',
//     graph: 'no',
//     graph_type: 'NA',
//     active: 'yes',
//     user_id: [],
//     print: [],
//     export: [],
//     email: [],
// };


// //==================================================================
// //  1. Custom Multi-Select Component with Search and Checkboxes
// //==================================================================
// const MultiSelectWithSearch = ({ options, selectedIds, onSelectionChange, placeholder, userMap }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const wrapperRef = useRef(null);

//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//                 setIsOpen(false);
//             }
//         }
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, [wrapperRef]);

//     const handleOptionToggle = (optionIdStr) => {
//         const newSelectedIds = selectedIds.includes(optionIdStr)
//             ? selectedIds.filter(id => id !== optionIdStr)
//             : [...selectedIds, optionIdStr];
//         onSelectionChange(newSelectedIds);
//     };

//     const filteredOptions = options.filter(option =>
//         option.name.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const handleSelectAllFiltered = () => {
//         const filteredIds = filteredOptions.map(opt => String(opt.id));
//         const allFilteredSelected = filteredIds.every(id => selectedIds.includes(id));
        
//         let newSelectedOptions;
//         if (allFilteredSelected) {
//             // Deselect all that are currently filtered
//             newSelectedOptions = selectedIds.filter(id => !filteredIds.includes(id));
//         } else {
//             // Select all that are currently filtered (and keep existing selections)
//             newSelectedOptions = [...new Set([...selectedIds, ...filteredIds])];
//         }
//         onSelectionChange(newSelectedOptions);
//     };

//     const getButtonLabel = () => {
//         if (selectedIds.length === 0) return placeholder || 'Select...';
//         if (selectedIds.length === 1) return userMap[selectedIds[0]] || `ID: ${selectedIds[0]}`;
//         return `${selectedIds.length} users selected`;
//     };

//     return (
//         <div className="custom-select-container" ref={wrapperRef}>
//             <button type="button" className="custom-select-button" onClick={() => setIsOpen(!isOpen)}>
//                 <span>{getButtonLabel()}</span>
//                 <span className={`arrow ${isOpen ? 'up' : 'down'}`}></span>
//             </button>
//             {isOpen && (
//                 <div className="custom-select-panel">
//                     <div className="search-wrapper">
//                         <input
//                             type="text"
//                             className="custom-select-search"
//                             placeholder="Search users..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             autoFocus
//                         />
//                     </div>
//                     <ul className="custom-select-options-list">
//                         {filteredOptions.length > 0 && (
//                             <li className="custom-select-option special-option" onClick={handleSelectAllFiltered}>
//                                 <input
//                                     type="checkbox"
//                                     readOnly
//                                     checked={filteredOptions.every(opt => selectedIds.includes(String(opt.id)))}
//                                 />
//                                 <label>Select All (Filtered)</label>
//                             </li>
//                         )}
//                         {filteredOptions.map(option => (
//                             <li key={option.id} className="custom-select-option" onClick={() => handleOptionToggle(String(option.id))}>
//                                 <input
//                                     type="checkbox"
//                                     checked={selectedIds.includes(String(option.id))}
//                                     readOnly
//                                 />
//                                 <label>{option.name}</label>
//                             </li>
//                         ))}
//                         {filteredOptions.length === 0 && <li className="no-options">No users found.</li>}
//                     </ul>
//                 </div>
//             )}
//         </div>
//     );
// };


// //==================================================================
// //  2. Main Report Manager Component
// //==================================================================
// const ReportManager = () => {
//     const [reports, setReports] = useState([]);
//     const [allUsers, setAllUsers] = useState([]);
//     const [userMap, setUserMap] = useState({});
//     const [searchTerm, setSearchTerm] = useState('');
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isFormVisible, setIsFormVisible] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);
//     const [currentReport, setCurrentReport] = useState(initialFormState);

//     const fetchUsers = useCallback(async () => {
//         try {
//             const token = localStorage.getItem('zTaskAuthToken');
//             const response = await fetch(`${API_BASE_URL}/reports/get-columns`, {
//                 method: 'POST',
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json',
//                     'Accept': 'application/json'
//                 },
//                 body: JSON.stringify({ table_name: "users", column_names: ["name"] })
//             });
//             if (!response.ok) throw new Error('Failed to fetch users');
//             const data = await response.json();
//             const users = data.data || [];
//             setAllUsers(users);
//             const idToNameMap = users.reduce((acc, user) => {
//                 acc[user.id] = user.name;
//                 return acc;
//             }, {});
//             setUserMap(idToNameMap);
//         } catch (err) {
//             setError(prev => (prev ? `${prev} | User Fetch Error: ${err.message}` : err.message));
//         }
//     }, []);

//     const fetchReports = useCallback(async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             const token = localStorage.getItem('zTaskAuthToken');
//             const response = await fetch(`${API_BASE_URL}/reports`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Accept': 'application/json'
//                 },
//             });
//             if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//             const data = await response.json();
//             setReports(data);
//         } catch (err) {
//             setError(err.message);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         const loadData = async () => {
//             await fetchUsers();
//             await fetchReports();
//         };
//         loadData();
//     }, [fetchReports, fetchUsers]);

//     const handleSearchChange = (event) => setSearchTerm(event.target.value);
//     const handleExportAll = () => alert("Export All functionality would be implemented here.");
//     const handleCloseForm = () => setIsFormVisible(false);

//     const handleOpenCreateForm = () => {
//         setIsEditing(false);
//         setCurrentReport(initialFormState);
//         setIsFormVisible(true);
//     };

//     const handleOpenEditForm = (report) => {
//         setIsEditing(true);
//         setCurrentReport({
//             ...report,
//             user_id: (report.user_id || []).map(String),
//             print: (report.print || []).map(String),
//             export: (report.export || []).map(String),
//             email: (report.email || []).map(String),
//         });
//         setIsFormVisible(true);
//     };

//     const handleFormChange = (event) => {
//         const { name, value } = event.target;
//         setCurrentReport(prev => ({ ...prev, [name]: value }));
//     };

//     const handlePermissionChange = (fieldName, selectedIds) => {
//         setCurrentReport(prev => ({
//             ...prev,
//             [fieldName]: selectedIds
//         }));
//     };

//     const handleFormSubmit = async (event) => {
//         event.preventDefault();
//         const reportData = {
//             ...currentReport,
//             user_id: currentReport.user_id.map(id => parseInt(id, 10)),
//             print: currentReport.print.map(id => parseInt(id, 10)),
//             export: currentReport.export.map(id => parseInt(id, 10)),
//             email: currentReport.email.map(id => parseInt(id, 10)),
//         };

//         if (!isEditing) delete reportData.id;
//         const url = isEditing ? `${API_BASE_URL}/reports/${currentReport.id}` : `${API_BASE_URL}/reports`;
//         const method = isEditing ? 'PUT' : 'POST';

//         try {
//             const token = localStorage.getItem('zTaskAuthToken');
//             const response = await fetch(url, {
//                 method,
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify(reportData)
//             });
//             if (!response.ok) {
//                 const errorBody = await response.text();
//                 throw new Error(`Failed to save report. Status: ${response.status}. Body: ${errorBody}`);
//             }
//             alert(`Report successfully ${isEditing ? 'updated' : 'created'}!`);
//             handleCloseForm();
//             await fetchReports();
//         } catch (err) {
//             alert(err.message);
//             console.error("Failed to save report:", err);
//         }
//     };

//     const filteredReports = reports.filter(report =>
//         (report.report_name && report.report_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//         (report.module_name && report.module_name.toLowerCase().includes(searchTerm.toLowerCase()))
//     );

//     const renderUserNames = (userIds) => {
//         if (!userIds || userIds.length === 0) return 'No users assigned';
//         return userIds.map(id => userMap[id] || `ID: ${id}`).join(', ');
//     };

//     return (
//         <div className="report-manager-container">
//             <h1>Report Management</h1>
//             <div className="top-bar">
//                 <input type="text" placeholder="Search reports..." className="search-bar" value={searchTerm} onChange={handleSearchChange}/>
//                 <div className="action-buttons">
//                     <button className="btn btn-secondary" onClick={handleExportAll}>Export All</button>
//                     <button className="btn btn-primary" onClick={handleOpenCreateForm}>Create Report</button>
//                 </div>
//             </div>

//             {loading && <p>Loading reports...</p>}
//             {error && <p className="error-message">Error: {error}</p>}

//             {!loading && !error && (
//                 <div className="table-container">
//                     <table>
//                         <thead>
//                             <tr>
//                                 <th>ID</th><th>Report Name</th><th>Module</th><th>Assigned Users</th>
//                                 <th>Active</th><th>Graph</th><th>Created On</th><th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredReports.length > 0 ? (
//                                 filteredReports.map(report => (
//                                     <tr key={report.id}>
//                                         <td>{report.id}</td>
//                                         <td>{report.report_name}</td>
//                                         <td>{report.module_name}</td>
//                                         <td>{renderUserNames(report.user_id)}</td>
//                                         <td><span className={`status ${report.active}`}>{report.active}</span></td>
//                                         <td>{report.graph}</td>
//                                         <td>{new Date(report.created_date_and_time).toLocaleDateString()}</td>
//                                         <td><button className="btn btn-edit" onClick={() => handleOpenEditForm(report)}>Edit</button></td>
//                                     </tr>
//                                 ))
//                             ) : ( <tr><td colSpan="8">No reports found.</td></tr> )}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {isFormVisible && (
//                 <div className="form-section-container">
//                     <form className="report-form" onSubmit={handleFormSubmit}>
//                         <div className="form-header">
//                             <h2>{isEditing ? 'Edit Report' : 'Create New Report'}</h2>
//                             <button type="button" className="close-button" onClick={handleCloseForm}>×</button>
//                         </div>

//                         <div className="form-group"><label>Report Name</label><input type="text" name="report_name" value={currentReport.report_name} onChange={handleFormChange} required /></div>
//                         <div className="form-group"><label>Module Name</label><input type="text" name="module_name" value={currentReport.module_name} onChange={handleFormChange} required /></div>
//                         <div className="form-group"><label>SQL Query</label><textarea name="sql_query" value={currentReport.sql_query} onChange={handleFormChange} rows="4" required></textarea></div>

//                         <fieldset className="permissions-fieldset">
//                             <legend>Report Permissions</legend>
//                             <div className="permissions-grid">
//                                 <div className="form-group">
//                                     <label>Users who can VIEW</label>
//                                     <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.user_id} onSelectionChange={(ids) => handlePermissionChange('user_id', ids)} placeholder="Select Viewers..." userMap={userMap} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Users who can PRINT</label>
//                                     <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.print} onSelectionChange={(ids) => handlePermissionChange('print', ids)} placeholder="Select Printers..." userMap={userMap} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Users who can EXPORT</label>
//                                     <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.export} onSelectionChange={(ids) => handlePermissionChange('export', ids)} placeholder="Select Exporters..." userMap={userMap} />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Users who can EMAIL</label>
//                                     <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.email} onSelectionChange={(ids) => handlePermissionChange('email', ids)} placeholder="Select Emailers..." userMap={userMap} />
//                                 </div>
//                             </div>
//                         </fieldset>

//                         <div className="form-group-inline">
//                             <div className="form-group"><label>Active</label><select name="active" value={currentReport.active} onChange={handleFormChange}><option value="yes">Yes</option><option value="no">No</option></select></div>
//                             <div className="form-group"><label>Enable Graph</label><select name="graph" value={currentReport.graph} onChange={handleFormChange}><option value="yes">Yes</option><option value="no">No</option></select></div>
//                         </div>

//                         <div className="form-footer">
//                             <button type="button" className="btn btn-secondary" onClick={handleCloseForm}>Cancel</button>
//                             <button type="submit" className="btn btn-primary">Save Changes</button>
//                         </div>
//                     </form>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ReportManager;



import React, { useState, useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import './Reports.css';
import { getReportsApiBaseUrl } from '../../config/reportsApi';
import { getReportModuleFilter, getDefaultReportModuleName } from '../../config/activeModule';
import { usePortalMenuPosition, useOutsideClose } from '../../hooks/usePortalDropdown';

// --- API Configuration ---
const API_BASE_URL = getReportsApiBaseUrl();
const initialFormState = {
    report_name: '',
    module_name: getDefaultReportModuleName(),
    sql_query: '',
    graph: 'no',
    graph_type: 'NA',
    active: 'yes',
    user_id: [],
    print: [],
    export: [],
    email: [],
};


//==================================================================
//  1. Custom Multi-Select Component with Search and Checkboxes
//==================================================================
const MultiSelectWithSearch = ({ options = [], selectedIds = [], onSelectionChange, placeholder, userMap = {} }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const wrapperRef = useRef(null);
    const menuRef = useRef(null);
    const { menuStyle } = usePortalMenuPosition(isOpen, wrapperRef);
    useOutsideClose(isOpen, setIsOpen, wrapperRef, menuRef, () => setSearchTerm(''));

    const safeOptions = Array.isArray(options) ? options : [];
    const safeSelected = Array.isArray(selectedIds) ? selectedIds.map(String) : [];

    const handleOptionToggle = (optionIdStr) => {
        const id = String(optionIdStr);
        const newSelectedIds = safeSelected.includes(id)
            ? safeSelected.filter((x) => x !== id)
            : [...safeSelected, id];
        onSelectionChange(newSelectedIds);
    };

    const filteredOptions = safeOptions.filter((option) =>
        String(option?.name || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelectAllFiltered = () => {
        const filteredIds = filteredOptions.map((opt) => String(opt.id));
        const allFilteredSelected = filteredIds.every((id) => safeSelected.includes(id));
        const newSelectedOptions = allFilteredSelected
            ? safeSelected.filter((id) => !filteredIds.includes(id))
            : [...new Set([...safeSelected, ...filteredIds])];
        onSelectionChange(newSelectedOptions);
    };

    const getButtonLabel = () => {
        if (safeSelected.length === 0) return placeholder || 'Select...';
        if (safeSelected.length === 1) return userMap[safeSelected[0]] || `ID: ${safeSelected[0]}`;
        return `${safeSelected.length} users selected`;
    };

    return (
        <div className={`custom-select-container${isOpen ? ' is-open' : ''}`} ref={wrapperRef}>
            <button type="button" className="custom-select-button" onClick={() => setIsOpen(!isOpen)}>
                <span>{getButtonLabel()}</span>
                <span className={`arrow ${isOpen ? 'up' : 'down'}`}></span>
            </button>
            {isOpen &&
                createPortal(
                    <div
                        className="custom-select-panel ui-portal-dropdown-menu report-permission-dropdown"
                        style={menuStyle}
                        ref={menuRef}
                    >
                        <div className="search-wrapper ui-portal-dropdown-search">
                            <input
                                type="text"
                                className="custom-select-search"
                                placeholder="Search users..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                autoFocus
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                        <ul className="custom-select-options-list">
                            {filteredOptions.length > 0 && (
                                <li className="custom-select-option special-option" onClick={handleSelectAllFiltered}>
                                    <input
                                        type="checkbox"
                                        readOnly
                                        checked={filteredOptions.every((opt) =>
                                            safeSelected.includes(String(opt.id))
                                        )}
                                    />
                                    <label>Select All (Filtered)</label>
                                </li>
                            )}
                            {filteredOptions.map((option) => (
                                <li
                                    key={option.id}
                                    className="custom-select-option"
                                    onClick={() => handleOptionToggle(String(option.id))}
                                >
                                    <input
                                        type="checkbox"
                                        checked={safeSelected.includes(String(option.id))}
                                        readOnly
                                    />
                                    <label>{option.name}</label>
                                </li>
                            ))}
                            {filteredOptions.length === 0 && (
                                <li className="no-options">No users found.</li>
                            )}
                        </ul>
                    </div>,
                    document.body
                )}
        </div>
    );
};


//==================================================================
//  2. Main Report Manager Component
//==================================================================
const ReportManager = () => {
    const [reports, setReports] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [userMap, setUserMap] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentReport, setCurrentReport] = useState(initialFormState);

    const fetchUsers = useCallback(async () => {
        try {
            const token = localStorage.getItem('zTaskAuthToken');
            // UPDATED: Added /api/ to the URL path
            const response = await fetch(`${API_BASE_URL}/api/reports/get-columns`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ table_name: "users", column_names: ["id", "name"] })
            });
            if (!response.ok) throw new Error('Failed to fetch users');
            const data = await response.json();
            const users = data.data || [];
            setAllUsers(users);
            const idToNameMap = users.reduce((acc, user) => {
                acc[String(user.id)] = user.name;
                return acc;
            }, {});
            setUserMap(idToNameMap);
        } catch (err) {
            setError(prev => (prev ? `${prev} | User Fetch Error: ${err.message}` : err.message));
        }
    }, []);

    const fetchReports = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('zTaskAuthToken');
            // UPDATED: Added /api/ to the URL path
            const response = await fetch(`${API_BASE_URL}/api/reports`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                },
            });
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const data = await response.json();
            const allowed = getReportModuleFilter();
            const filtered = (Array.isArray(data) ? data : []).filter((report) =>
                allowed.includes((report.module_name || '').toLowerCase())
            );
            setReports(filtered);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const loadData = async () => {
            await fetchUsers();
            await fetchReports();
        };
        loadData();
    }, [fetchReports, fetchUsers]);

    const handleSearchChange = (event) => setSearchTerm(event.target.value);
    const handleExportAll = () => alert("Export All functionality would be implemented here.");
    const handleCloseForm = () => setIsFormVisible(false);

    const handleOpenCreateForm = () => {
        setIsEditing(false);
        setCurrentReport(initialFormState);
        setIsFormVisible(true);
    };

    const handleOpenEditForm = (report) => {
        setIsEditing(true);
        setCurrentReport({
            ...report,
            user_id: (report.user_id || []).map(String),
            print: (report.print || []).map(String),
            export: (report.export || []).map(String),
            email: (report.email || []).map(String),
        });
        setIsFormVisible(true);
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setCurrentReport(prev => ({ ...prev, [name]: value }));
    };

    const handlePermissionChange = (fieldName, selectedIds) => {
        setCurrentReport(prev => ({
            ...prev,
            [fieldName]: selectedIds
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const reportData = {
            ...currentReport,
            user_id: currentReport.user_id.map(id => parseInt(id, 10)),
            print: currentReport.print.map(id => parseInt(id, 10)),
            export: currentReport.export.map(id => parseInt(id, 10)),
            email: currentReport.email.map(id => parseInt(id, 10)),
        };

        if (!isEditing) delete reportData.id;
        
        // UPDATED: Added /api/ to the URL paths
        const url = isEditing ? `${API_BASE_URL}/api/reports/${currentReport.id}` : `${API_BASE_URL}/api/reports`;
        const method = isEditing ? 'PUT' : 'POST';

        try {
            const token = localStorage.getItem('zTaskAuthToken');
            const response = await fetch(url, {
                method,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(reportData)
            });
            if (!response.ok) {
                const errorBody = await response.text();
                throw new Error(`Failed to save report. Status: ${response.status}. Body: ${errorBody}`);
            }
            alert(`Report successfully ${isEditing ? 'updated' : 'created'}!`);
            handleCloseForm();
            await fetchReports();
        } catch (err) {
            alert(err.message);
            console.error("Failed to save report:", err);
        }
    };

    const filteredReports = reports.filter(report =>
        (report.report_name && report.report_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (report.module_name && report.module_name.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const renderUserNames = (userIds) => {
        if (!userIds || userIds.length === 0) return 'No users assigned';
        return userIds.map(id => userMap[id] || `ID: ${id}`).join(', ');
    };

    return (
        <div className="report-manager-container">
            <h1>Report Management</h1>
            <div className="top-bar">
                <input type="text" placeholder="Search reports..." className="search-bar" value={searchTerm} onChange={handleSearchChange}/>
                <div className="action-buttons">
                    <button className="btn btn-secondary" onClick={handleExportAll}>Export All</button>
                    <button className="btn btn-primary" onClick={handleOpenCreateForm}>Create Report</button>
                </div>
            </div>

            {loading && <p>Loading reports...</p>}
            {error && <p className="error-message">Error: {error}</p>}

            {!loading && !error && (
                <div className="table-scroll-wrapper">
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th><th>Report Name</th><th>Module</th><th>Assigned Users</th>
                                <th>Active</th><th>Graph</th><th>Created On</th><th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredReports.length > 0 ? (
                                filteredReports.map(report => (
                                    <tr key={report.id}>
                                        <td>{report.id}</td>
                                        <td>{report.report_name}</td>
                                        <td>{report.module_name}</td>
                                        <td>{renderUserNames(report.user_id)}</td>
                                        <td><span className={`status ${report.active}`}>{report.active}</span></td>
                                        <td>{report.graph}</td>
                                        <td>{new Date(report.created_date_and_time).toLocaleDateString()}</td>
                                        <td><button className="btn btn-edit" onClick={() => handleOpenEditForm(report)}>Edit</button></td>
                                    </tr>
                                ))
                            ) : ( <tr><td colSpan="8">No reports found.</td></tr> )}
                        </tbody>
                    </table>
                </div>
                </div>
            )}

            {isFormVisible && (
                <div className="form-section-container">
                    <form className="report-form" onSubmit={handleFormSubmit}>
                        <div className="form-header">
                            <h2>{isEditing ? 'Edit Report' : 'Create New Report'}</h2>
                            <button type="button" className="close-button" onClick={handleCloseForm}>×</button>
                        </div>

                        <div className="form-group"><label>Report Name</label><input type="text" name="report_name" value={currentReport.report_name} onChange={handleFormChange} required /></div>
                        <div className="form-group"><label>Module Name</label><input type="text" name="module_name" value={currentReport.module_name} onChange={handleFormChange} required /></div>
                        <div className="form-group"><label>SQL Query</label><textarea name="sql_query" value={currentReport.sql_query} onChange={handleFormChange} rows="4" required></textarea></div>

                        <fieldset className="permissions-fieldset">
                            <legend>Report Permissions</legend>
                            <div className="permissions-grid">
                                <div className="form-group">
                                    <label>Users who can VIEW</label>
                                    <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.user_id} onSelectionChange={(ids) => handlePermissionChange('user_id', ids)} placeholder="Select Viewers..." userMap={userMap} />
                                </div>
                                <div className="form-group">
                                    <label>Users who can PRINT</label>
                                    <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.print} onSelectionChange={(ids) => handlePermissionChange('print', ids)} placeholder="Select Printers..." userMap={userMap} />
                                </div>
                                <div className="form-group">
                                    <label>Users who can EXPORT</label>
                                    <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.export} onSelectionChange={(ids) => handlePermissionChange('export', ids)} placeholder="Select Exporters..." userMap={userMap} />
                                </div>
                                <div className="form-group">
                                    <label>Users who can EMAIL</label>
                                    <MultiSelectWithSearch options={allUsers} selectedIds={currentReport.email} onSelectionChange={(ids) => handlePermissionChange('email', ids)} placeholder="Select Emailers..." userMap={userMap} />
                                </div>
                            </div>
                        </fieldset>

                        <div className="form-group-inline">
                            <div className="form-group"><label>Active</label><select name="active" value={currentReport.active} onChange={handleFormChange}><option value="yes">Yes</option><option value="no">No</option></select></div>
                            <div className="form-group"><label>Enable Graph</label><select name="graph" value={currentReport.graph} onChange={handleFormChange}><option value="yes">Yes</option><option value="no">No</option></select></div>
                        </div>

                        <div className="form-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleCloseForm}>Cancel</button>
                            <button type="submit" className="btn btn-primary">Save Changes</button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default ReportManager;